import { render } from "./FlyerSection.vue?vue&type=template&id=5006fbbf"
const script = {}

import "./FlyerSection.vue?vue&type=style&index=0&id=5006fbbf&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__